import { css } from "@emotion/react";

export default () => ({
  content: css``,
});
